"use client";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useTranslations } from "next-intl";

interface LinkItem {
  key: "home" | "skills" | "services" | "resume" | "work";
  path: string;
}

const links: LinkItem[] = [
  { key: "home", path: "/" },
  { key: "skills", path: "/skills" },
  { key: "services", path: "/services" },
  { key: "resume", path: "/resume" },
  { key: "work", path: "/work" },
];

const Nav = () => {
  const pathname = usePathname();
  const t = useTranslations("common.nav");
  return (
    <nav className="flex gap-8">
      {links.map((link, index) => {
        return (
          <Link
            href={link.path}
            key={index}
            className={`capitalize font-medium hover:text-accent transition-all cursor-target ${
              link.path === pathname && "text-accent border-b-2 border-accent"
            }`}
          >
            {t(link.key)}
          </Link>
        );
      })}
    </nav>
  );
};

export default Nav;
